import { Command } from 'prosemirror-state';
import { CommandProps } from '../types';
import { BaseNode } from './base/BaseNode';

export class HardBreak extends BaseNode {
  constructor() {
    super('hard_break');
  }

  get schema() {
    return {
      inline: true,
      group: 'inline',
      selectable: false,
      parseDOM: [{ tag: 'br' }],
      toDOM() {
        return ['br'] as const;
      },
      leafText: () => '\n',
    };
  }

  commands({ schema }: CommandProps): Record<string, Command> {
    return {
      'Shift-Enter': (state, dispatch) => {
        // const isParagraphActive = isNodeActive(state.schema.nodes.paragraph, {}, state);
        // if (
        //   (!isInTable(state) && !isParagraphActive) ||
        //   isInCode(state, { onlyBlock: true })
        // ) {
        //   return false;
        // }
        dispatch?.(
          state.tr.replaceSelectionWith(schema.nodes.hard_break.create()).scrollIntoView()
        );
        return true;
      },
    };
  }
}
